var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
            _vm.templateType ===
            _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.PURCHASE_ORDER].route
        )?_c('PurchaseOrder'):_vm._e(),(_vm.templateType === _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.LETTER].route)?_c('Letter',{ref:"letterDetail"}):_vm._e(),(
            _vm.templateType ===
            _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.MEDICAL_NOTE].route
        )?_c('MedicalNote',{ref:"medicalNoteDetail"}):_vm._e(),(_vm.templateType === _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.BUNDLE].route)?_c('Invoice',{ref:"invoiceDetail"}):_vm._e(),(
            _vm.templateType ===
            _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.BUNDLE_ESTIMATE].route
        )?_c('Estimate',{ref:"estimateDetail"}):_vm._e(),(
            _vm.templateType ===
            _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.WELLNESS_PLAN].route
        )?_c('WellnessPlan',{ref:"wellnessPlanDetail"}):_vm._e(),(
            _vm.templateType === _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.ATTACHMENT].route
        )?_c('Attachment'):_vm._e(),(
            _vm.templateType ===
            _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.CONTENT_SNIPPET].route
        )?_c('ContentSnippet',{ref:"snippetDetail"}):_vm._e(),(
            _vm.templateType ===
            _vm.TEMPLATES.LIST[_vm.TEMPLATES.TYPE.WEBFORM_TEMPLATE].route
        )?_c('Webform',{ref:"webformDetail",on:{"setFormDirty":function (isDirty) { return (_vm.form_dirty = isDirty); }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }